<template>
  <CommonPages class="all-cars" headerTheme="dark" titlePrefix="Category">
    <div class="all-cars__main-container">
      <!-- 筛选器部分移到右侧，在PC端 -->
      <div class="all-cars__content">
        <!-- 车辆列表 -->
        <div class="all-cars__cards">
          <template v-for="(car, index) in filteredCars">
            <a :key="`car-${index}`" class="all-cars__card" :href="getCarDetailUrl(car)">

              <div class="all-cars__car-header">
                <div class="all-cars__brand-logo">
                  <img :src="car.logoUrl" alt="brand logo">
                </div>
                <div class="all-cars__car-info">
                  <div class="all-cars__model">{{ car.model }}</div>
                  <div class="all-cars__brand">{{ car.brand }}</div>
                </div>
              </div>
              <!-- 车辆图片 -->
              <img :src="car.image" class="all-cars__pic" alt="car image">

              <!-- 车辆信息 -->
              <div class="all-cars__info">
                <!-- 车辆类型 -->
                <div class="all-cars__feature">
                  <img src="@/assets/calendar.svg" class="all-cars__icon" alt="year type">
                  <div class="all-cars__feature-text">{{ car.year }}</div>
                </div>

                <!-- 车辆类型 -->
                <div class="all-cars__feature">
                  <img src="@/assets/car-type.svg" class="all-cars__icon" alt="car type">
                  <div class="all-cars__feature-text">{{ car.purpose }}</div>
                </div>

                <!-- 车身类型 -->
                <div class="all-cars__feature">
                  <img src="@/assets/body-type.svg" class="all-cars__icon" alt="body type">
                  <div class="all-cars__feature-text">{{ car.bodyType }}</div>
                </div>

                <div class="all-cars__feature">
                  <img src="@/assets/homehero/Budget.svg" class="all-cars__icon" alt="Budget type">
                  <div class="all-cars__feature-text">{{ car.priceDisplay }}</div>
                </div>
              </div>

              <!-- 价格信息 -->
              <div class="all-cars__price">
                <div class="all-cars__price-head">Rate</div>
                <div class="all-cars__price-text">{{ car.rate }} <span>/ 10</span></div>
              </div>

            </a>

            <!-- 广告位置1显示all_1 -->
            <!-- <AdComponent
              v-if="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.all_1 && shouldInsertAdDeviece('detailInsert',index) === 0"
              :key="`ad_all_1_${index}`" :ref="'ads-all-insert-1-' + index"
              class="ads-all-insert ads-insert-max ads-insert" :ads="adsensConfig?.all_1"
              :showDebug="showDebug" /> -->

            <!-- 插入广告 -->
            <div v-if="$global.isObjectNotEmpty(adsensConfig) && shouldInsertAd(index) !== -1"
              :key="`ad_${index}`" class="ad-width-100 ad-pos-row" data-ad-placement="list_1"
              data-ad-source-placement="list_1">
              <AdComponent v-if="adsensConfig?.all?.[shouldInsertAd(index)]" :ref="'ads-' + index"
                class="recommand-ads" :ads="adsensConfig?.all[shouldInsertAd(index)]"
                :showDebug="showDebug" />
            </div>

          </template>

        </div>

        <!-- 无数据提示 -->
        <div class="all-cars__no-results" v-show="filteredCars.length === 0 && !isLoading">
          <p class="all-cars__no-results-text">No vehicles found that match the criteria</p>
        </div>

        <!-- 移动端加载更多提示 -->
        <div class="all-cars__load-more" v-show="deviceType === 'mobile' && cars.length > 0">
          <p class="all-cars__load-more-text" v-if="isLoading">Loading...</p>
          <p class="all-cars__load-more-text" v-else-if="currentPage >= totalPages">No more data</p>
          <p class="all-cars__load-more-text" v-else>Scroll up to load more</p>
        </div>

        <!-- 分页区域 - 只在PC端显示 -->
        <div class="all-cars__pagination" v-if="deviceType === 'pc' || deviceType === 'desktop'">
          <!-- 左箭头 -->
          <div class="all-cars__pagination-arrow" @click="goToPage(currentPage - 1)"
            v-if="currentPage > 1">
            <img src="@/assets/arrow-left.svg" alt="Previous"
              class="all-cars__pagination-arrow-icon">
          </div>

          <!-- 显示第一页 -->
          <div class="all-cars__pagination-page"
            :class="{'all-cars__pagination-page--active': currentPage === 1}" @click="goToPage(1)">1
          </div>

          <!-- 如果当前页大于4，显示省略号 -->
          <div v-if="currentPage > 4" class="all-cars__pagination-ellipsis">...</div>

          <!-- 显示当前页前后两页 -->
          <template v-for="page in displayedPages">
            <div class="all-cars__pagination-page" :key="`page-${page}`"
              :class="{'all-cars__pagination-page--active': currentPage === page}"
              @click="goToPage(page)">{{ page }}</div>
          </template>

          <!-- 如果当前页小于总页数-3，显示省略号 -->
          <div v-if="currentPage < totalPages - 3" class="all-cars__pagination-ellipsis">...</div>

          <!-- 显示最后一页 -->
          <div class="all-cars__pagination-page"
            :class="{'all-cars__pagination-page--active': currentPage === totalPages}"
            @click="goToPage(totalPages)" v-if="totalPages > 1">{{ totalPages }}</div>

          <!-- 右箭头 -->
          <div class="all-cars__pagination-arrow" @click="goToPage(currentPage + 1)"
            v-if="currentPage < totalPages">
            <img src="@/assets/arrow-right.svg" alt="Next" class="all-cars__pagination-arrow-icon">
          </div>
        </div>
      </div>

      <!-- 筛选器部分 - 右侧 -->
      <div class="all-cars__filters">
        <!-- 类型筛选 -->
        <div class="all-cars__filter-section"
          v-if="!domainConfig?.themeFilters?.type || domainConfig.themeFilters.type === 'all'">
          <div class="all-cars__filter-title">Type :</div>
          <div class="all-cars__filter-options">
            <div v-for="(option, index) in filterOptions.types" :key="`type-${index}`"
              class="all-cars__filter-option"
              :class="{'all-cars__filter-option--active': selectedFilters.type === option.value}"
              @click="updateFilter('type', option.value, $event)">
              {{ option.label }}
            </div>
          </div>
        </div>

        <!-- 价格筛选 -->
        <div class="all-cars__filter-section">
          <div class="all-cars__filter-title">Ex-Showroom Price :</div>
          <div class="all-cars__filter-options">
            <div v-for="(option, index) in filterOptions.prices" :key="`price-${index}`"
              class="all-cars__filter-option"
              :class="{'all-cars__filter-option--active': selectedFilters.price === option.value}"
              @click="updateFilter('price', option.value, $event)">
              {{ option.label }}
            </div>
          </div>
        </div>

        <!-- 燃料类型筛选 -->
        <div class="all-cars__filter-section"
          v-if="!domainConfig?.themeFilters?.fuel || domainConfig.themeFilters.fuel === 'all'">
          <div class="all-cars__filter-title">Fuel :</div>
          <div class="all-cars__filter-options">
            <div v-for="(option, index) in filterOptions.fuels" :key="`fuel-${index}`"
              class="all-cars__filter-option"
              :class="{'all-cars__filter-option--active': selectedFilters.fuel === option.value}"
              @click="updateFilter('fuel', option.value, $event)">
              {{ option.label }}
            </div>
          </div>
        </div>

        <!-- 用途筛选 -->
        <div class="all-cars__filter-section"
          v-if="!domainConfig?.themeFilters?.purpose || domainConfig.themeFilters.purpose === 'all'">
          <div class="all-cars__filter-title">Purpose :</div>
          <div class="all-cars__filter-options">
            <div v-for="(option, index) in filterOptions.purposes" :key="`purpose-${index}`"
              class="all-cars__filter-option"
              :class="{'all-cars__filter-option--active': selectedFilters.purpose === option.value}"
              @click="updateFilter('purpose', option.value, $event)">
              {{ option.label }}
            </div>
          </div>
        </div>

        <!-- 品牌筛选 -->
        <div class="all-cars__filter-section"
          v-if="!domainConfig?.themeFilters?.brand || domainConfig.themeFilters.brand === 'all'">
          <div class="all-cars__filter-title">Brands :</div>
          <div class="all-cars__filter-options"
            :class="{'all-cars__filter-options--expanded': brandExpanded}">
            <div v-for="(brand, index) in visibleBrands" :key="`brand-${index}`"
              class="all-cars__filter-option"
              :class="{'all-cars__filter-option--active': selectedFilters.brand === brand.value}"
              @click="updateFilter('brand', brand.value, $event)">
              {{ brand.label }}
            </div>
          </div>
        </div>
      </div>

      <!-- 移动端筛选器 - 保持在顶部 -->
      <div class="all-cars__mobile-filters" v-if="deviceType === 'mobile'">
        <!-- 类型筛选 -->
        <div class="all-cars__filter"
          v-if="!domainConfig?.themeFilters?.type || domainConfig.themeFilters.type === 'all'">
          <div class="all-cars__filter-label">Type :</div>
          <div class="all-cars__filter-items">
            <div v-for="(option, index) in filterOptions.types" :key="`type-${index}`"
              class="all-cars__filter-item"
              :class="{'all-cars__filter-item--active': selectedFilters.type === option.value}"
              @click="updateFilter('type', option.value, $event)">
              {{ option.label }}
            </div>
          </div>
        </div>

        <!-- 价格筛选 -->
        <div class="all-cars__filter">
          <div class="all-cars__filter-label">Ex-Showroom Price :</div>
          <div class="all-cars__filter-items">
            <div v-for="(option, index) in filterOptions.prices" :key="`price-${index}`"
              class="all-cars__filter-item"
              :class="{'all-cars__filter-item--active': selectedFilters.price === option.value}"
              @click="updateFilter('price', option.value, $event)">
              {{ option.label }}
            </div>
          </div>
        </div>

        <!-- 燃料类型筛选 -->
        <div class="all-cars__filter"
          v-if="!domainConfig?.themeFilters?.fuel || domainConfig.themeFilters.fuel === 'all'">
          <div class="all-cars__filter-label">Fuel :</div>
          <div class="all-cars__filter-items">
            <div v-for="(option, index) in filterOptions.fuels" :key="`fuel-${index}`"
              class="all-cars__filter-item"
              :class="{'all-cars__filter-item--active': selectedFilters.fuel === option.value}"
              @click="updateFilter('fuel', option.value, $event)">
              {{ option.label }}
            </div>
          </div>
        </div>

        <!-- 品牌筛选 -->
        <div class="all-cars__filter brand"
          v-if="!domainConfig?.themeFilters?.brand || domainConfig.themeFilters.brand === 'all'">
          <div class="all-cars__filter-label brand">Brand :</div>
          <div class="all-cars__filter-items"
            :class="{'all-cars__filter-items--expanded': brandExpanded}">
            <div v-for="(brand, index) in visibleBrands" :key="`brand-${index}`"
              class="all-cars__filter-item"
              :class="{'all-cars__filter-item--active': selectedFilters.brand === brand.value}"
              @click="updateFilter('brand', brand.value, $event)">
              {{ brand.label }}
            </div>
          </div>
        </div>

        <!-- 用途筛选 -->
        <div class="all-cars__filter"
          v-if="!domainConfig?.themeFilters?.purpose || domainConfig.themeFilters.purpose === 'all'">
          <div class="all-cars__filter-label">Purpose :</div>
          <div class="all-cars__filter-items">
            <div v-for="(option, index) in filterOptions.purposes" :key="`purpose-${index}`"
              class="all-cars__filter-item"
              :class="{'all-cars__filter-item--active': selectedFilters.purpose === option.value}"
              @click="updateFilter('purpose', option.value, $event)">
              {{ option.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import AdComponent from '@/pages/components/AdComponent.vue'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import reportMixin from '@/mixin/reportMixin.js'

import '@/css/home.scss';

export default {
  mixins: [adMixin, adTrackingMixin, reportMixin],
  name: 'AllCars',
  components: {
    CommonPages,
    AdComponent
  },
  props: {
    channel: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
      'adsensConfig',
      'adPosConfig',
      'showDebug',
      'brandList',
      'brandListLoaded'
    ]),
    // 计算需要显示的页码
    displayedPages () {
      const pages = [];
      const min = Math.max(2, this.currentPage - 2);
      const max = Math.min(this.totalPages - 1, this.currentPage + 2);

      for (let i = min; i <= max; i++) {
        pages.push(i);
      }

      return pages;
    },
    filteredCars () {
      return this.cars;
    },
    visibleBrands () {
      return this.brandList;
    }
  },
  data () {
    return {
      // 筛选选项
      filterOptions: {
        types: [
          { label: 'All', value: 'all' },
          { label: 'SUV', value: 'SUV' },
          { label: 'Sedan', value: 'Sedan' },
          { label: 'Wagon', value: 'Wagon' },
          { label: 'Coupe', value: 'Coupe' },
          { label: 'Convertible', value: 'Convertible' },
          { label: 'Pickup Truck', value: 'Pickup Truck' },
          { label: 'Hatchback', value: 'Hatchback' },
          { label: 'Van', value: 'Van' }
        ],
        prices: [
          { label: 'All', value: 'all' },
          { label: 'Less than $20,000', value: 'less_20000' },
          { label: '$20,001 - $40,000', value: '20001_40000' },
          { label: '$40,001 - $60,000', value: '40001_60000' },
          { label: '$60,001 - $80,000', value: '60001_80000' },
          { label: 'More than $80,000', value: 'more_80001' }
        ],
        fuels: [
          { label: 'All', value: 'all' },
          { label: 'Gasoline', value: 'Gasoline' },
          { label: 'Diesel', value: 'Diesel' },
          { label: 'EV', value: 'EV' },
          { label: 'Hybrid', value: 'Hybrid' },
          { label: 'PHEV', value: 'PHEV' },
          { label: 'Hydrogen Cell', value: 'Hydrogen cell' }
        ],
        purposes: [
          { label: 'All', value: 'all' },
          { label: 'Family Vehicle', value: 'Family Vehicle' },
          { label: 'Commercial Vehicle', value: 'Commercial Vehicle' },
          { label: 'Cross Country Vehicle', value: 'Cross Country Vehicle' },
          { label: 'Sport Vehicle', value: 'Sport Vehicle' }
        ]
      },
      // 当前选中的筛选项
      selectedFilters: {
        type: 'all',
        price: 'all',
        fuel: 'all',
        purpose: 'all',
        brand: 'all'
      },
      // 品牌展开/折叠状态
      brandExpanded: false,
      // 分页相关
      currentPage: 1,
      totalPages: 1,
      pageSize: 12, // 每页显示数量
      total: 0,
      scrollThreshold: 2000, // 移动端滚动触发阈值
      scrollHandler: null,
      isLoading: false,
      // 车辆数据
      cars: [],
      // API请求参数
      apiParams: {
        pageSize: 12,
        pageNum: 1,
        type: '',
        leastPrice: '',
        mostPrice: '',
        brand: '',
        purpose: ''
      },
      // 以下属性已被合并到现有属性中
      // carList: [],
      // loading: false,
      // error: null
    }
  },
  created () {
    this.checkUrlParams()

    // 初始化localPage
    this.localPage = this.currentPage || 1

    // 根据domainConfig中的themeFilters设置初始筛选值
    this.applyThemeFilters()
  },
  async mounted () {
    // 确保只在浏览器环境中执行DOM操作
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    // 检查Vuex状态
    this.checkVuexState()

    // 添加滚动监听
    if (this.deviceType === 'mobile') {
      window.addEventListener('scroll', this.scrollHandler)
    }

    // await this.initAdSystem();
    // // 确保在广告系统初始化后再初始化跟踪
    // this.$nextTick(() => {
    //   this.initAdTracking();
    // });

    // 组件挂载后，滚动到选中的选项位置
    this.$nextTick(() => {
      this.scrollToSelectedOptions()
    })
  },
  updated () {
    // 确保只在浏览器环境中执行DOM操作
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    // 在组件更新后，滚动到选中的选项位置
    this.$nextTick(() => {
      this.scrollToSelectedOptions()
    })
  },
  beforeRouteLeave (to, from, next) {
    // 如果要离开all页面去往首页，则重置vuex状态
    if (to.name === 'Home' || to.path === '/' || to.path.includes('/home')) {
      console.log('[All] Navigating to home page, resetting state')
      this.$store.commit('RESET_CAR_LIST_STATE')
    }
    next()
  },
  beforeMount () {
    // 确保只在浏览器环境中进行DOM操作
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      console.log('SSR环境下跳过DOM操作初始化');
      return;
    }

    // 创建防抖的滚动处理函数
    this.scrollHandler = this.debounce(this.onScroll, 200);

    // 检查URL参数
    this.checkUrlParams();

    // 获取车辆列表数据
    this.fetchCarList();

    // 检查当前选中的品牌是否在默认显示范围内
    this.checkSelectedBrandVisibility();
  },
  beforeDestroy () {
    // 移除滚动监听
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler)
    }
  },
  methods: {
    //广告相关start
    shouldInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.deviceType == 'mobile' ? this.adPosConfig.homeRecommand.indexOf(position) : this.adPosConfig.homeRecommandPC.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    // 应用domainConfig中的主题筛选设置
    applyThemeFilters () {
      // 获取domainConfig中的themeFilters配置
      const themeFilters = this.domainConfig?.themeFilters || {}

      // 遍历所有可能的筛选字段
      Object.keys(themeFilters).forEach(filterType => {
        const filterValue = themeFilters[filterType]

        // 如果themeFilters中指定了非'all'的值，设置为初始选中值
        if (filterValue && filterValue !== 'all' && this.selectedFilters[filterType] === 'all') {
          console.log(`[All] Applying theme filter: ${filterType} = ${filterValue}`)
          this.selectedFilters[filterType] = filterValue
        }
      })
    },

    // 添加滚动到选中选项的方法
    scrollToSelectedOptions () {
      // 确保方法只在浏览器环境中执行
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        console.log('SSR环境下跳过DOM操作');
        return;
      }

      // 获取所有筛选类型
      const filterTypes = ['type', 'price', 'fuel', 'brand', 'purpose']

      // 对每个筛选类型处理
      filterTypes.forEach(type => {
        // 如果该类型有选中项且不是'all'
        if (this.selectedFilters[type] && this.selectedFilters[type] !== 'all') {
          // 获取所有筛选容器
          const filterContainers = document.querySelectorAll('.all-cars__filter-items')

          // 遍历筛选容器
          filterContainers.forEach(container => {
            // 在当前容器中查找选中项
            const activeItem = container.querySelector('.all-cars__filter-item--active')

            if (activeItem) {
              // 查找与当前筛选类型匹配的选中项
              // 通过判断activeItem所在的筛选类型
              let isMatchingType = false

              // 获取activeItem的文本内容，检查是否匹配当前筛选值
              const activeItemText = activeItem.textContent.trim()
              let filterOptions = []

              // 根据筛选类型获取对应的选项列表
              switch (type) {
                case 'type':
                  filterOptions = this.filterOptions.types
                  break
                case 'price':
                  filterOptions = this.filterOptions.prices
                  break
                case 'fuel':
                  filterOptions = this.filterOptions.fuels
                  break
                case 'brand':
                  filterOptions = this.brandList
                  break
                case 'purpose':
                  filterOptions = this.filterOptions.purposes
                  break
              }

              // 找到匹配当前选中值的选项
              const matchingOption = filterOptions.find(option =>
                option.value === this.selectedFilters[type]
              )

              // 如果找到匹配的选项，检查文本是否匹配
              if (matchingOption && activeItemText === matchingOption.label) {
                isMatchingType = true
              }

              // 如果是匹配的类型，则滚动到该位置
              if (isMatchingType) {
                // 计算滚动位置
                const scrollLeft = activeItem.offsetLeft - 20

                // 设置滚动位置
                container.scrollLeft = scrollLeft > 0 ? scrollLeft : 0

                console.log(`滚动到选中的${type}选项位置: ${activeItemText}`)
              }
            }
          })
        }
      })
    },

    // 切换品牌筛选的展开/折叠状态
    toggleBrandExpand () {
      // 确保方法只在浏览器环境中执行
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        console.log('SSR环境下跳过DOM操作');
        this.brandExpanded = !this.brandExpanded;
        return;
      }

      this.brandExpanded = !this.brandExpanded;

      // 展开后，滚动到选中的品牌位置（仅在PC端生效）
      if (this.brandExpanded && this.selectedFilters.brand !== 'all' && this.deviceType !== 'mobile') {
        this.$nextTick(() => {
          // 获取品牌筛选容器
          const container = document.querySelector('.all-cars__filter.brand .all-cars__filter-items')

          if (container) {
            // 找到匹配选中品牌值的选项
            const matchingOption = this.brandList.find(option =>
              option.value === this.selectedFilters.brand
            )

            if (matchingOption) {
              // 找到对应标签文本的选项元素
              const items = container.querySelectorAll('.all-cars__filter-item')
              let activeItem = null

              items.forEach(item => {
                if (item.textContent.trim() === matchingOption.label) {
                  activeItem = item
                }
              })

              if (activeItem) {
                // 计算滚动位置
                const scrollLeft = activeItem.offsetLeft - 20

                // 设置滚动位置
                container.scrollLeft = scrollLeft > 0 ? scrollLeft : 0

                console.log(`展开品牌后滚动到选中品牌: ${matchingOption.label}`)
              }
            }
          }
        })
      }
    },

    // 获取车辆列表数据
    async fetchCarList () {
      this.isLoading = true
      try {
        const params = this.getSearchParams()
        console.log('请求车辆列表', params)

        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.domainConfig?.themeFilters || {};
        // 获取webIndex
        const webIndex = this.domainConfig?.webIndex || 1;
        console.log('[All] 应用域名主题过滤条件:', themeFilters);

        // 对于用户已选择的筛选条件，不使用themeFilters覆盖
        const mergedParams = {
          ...params,
          webIndex
        };

        // 将themeFilters中的设置添加到请求参数，但不覆盖用户已选择的筛选条件
        Object.keys(themeFilters).forEach(key => {
          // 只有当用户没有选择特定筛选条件(参数不存在)，且themeFilters中的值不是'all'时，才添加themeFilters中的设置
          if (!mergedParams[key] && themeFilters[key] !== 'all') {
            mergedParams[key] = themeFilters[key];
          }
        });

        console.log('[All] 最终请求参数:', mergedParams);
        const response = await this.$global.server.searchCar(mergedParams)
        if (response && response.code === 200) {
          if (response.data && response.data.list) {
            console.log('请求车辆列表', response.data.list)
            this.cars = response.data.list.map(this.formatCarData)
            console.log(this.cars);
            // 更新总数并计算总页数
            this.total = response.data.total || response.data.list.length
            this.totalPages = Math.ceil(this.total / this.pageSize)
          } else {
            this.cars = []
            this.total = 0
            this.totalPages = 1
          }
        } else {
          this.cars = []
          this.total = 0
          this.totalPages = 1
        }
        return Promise.resolve()
      } catch (error) {
        console.error('获取车辆列表出错', error)
        this.cars = []
        this.total = 0
        this.totalPages = 1
        return Promise.reject(error)
      } finally {
        this.isLoading = false
      }
    },

    // 将API返回的车辆数据格式化为页面需要的格式
    formatCarData (item) {
      // 格式化车辆数据以便在页面上显示
      const formattedItem = { ...item }
      // console.log(item);
      formattedItem.logo = item.logoUrl || require('@/assets/car-logo.svg')

      formattedItem.image = item.cover

      // 处理名称
      if (!formattedItem.model && item.name) {
        formattedItem.model = item.name
      }

      // 处理价格 - 优先使用leastPrice和mostPrice字段格式化价格
      if (item.leastPrice || item.mostPrice) {
        formattedItem.priceDisplay = this.formatPrice(item.leastPrice, item.mostPrice)
      }
      // 如果没有leastPrice和mostPrice，但有price字段，尝试从price字段提取价格
      else if (item.price && typeof item.price === 'string') {
        // 检查是否是特殊格式的price字符串，如 "most price {$92,900},least price {$69,900}"
        const mostPriceMatch = item.price.match(/most\s+price\s+\{\$([\d,]+)\}/)
        const leastPriceMatch = item.price.match(/least\s+price\s+\{\$([\d,]+)\}/)

        let extractedMostPrice = null
        let extractedLeastPrice = null

        if (mostPriceMatch && mostPriceMatch[1]) {
          // 提取most price并转换为数字
          extractedMostPrice = parseInt(mostPriceMatch[1].replace(/,/g, ''), 10)
        }

        if (leastPriceMatch && leastPriceMatch[1]) {
          // 提取least price并转换为数字
          extractedLeastPrice = parseInt(leastPriceMatch[1].replace(/,/g, ''), 10)
        }

        // 使用提取的价格格式化
        if (extractedLeastPrice || extractedMostPrice) {
          formattedItem.priceDisplay = this.formatPrice(extractedLeastPrice, extractedMostPrice)
        } else {
          // 如果无法从price字符串提取价格，则直接使用price字段
          formattedItem.priceDisplay = item.price
        }
      } else {
        // 没有价格信息
        formattedItem.priceDisplay = 'Price upon request'
      }

      // 确保category和bodyType有值
      if (!formattedItem.category && item.type) {
        formattedItem.category = item.type
      }

      if (!formattedItem.bodyType) {
        formattedItem.bodyType = formattedItem.category || formattedItem.type || 'N/A'
      }

      return formattedItem
    },

    // 格式化数字为千分位
    formatNumber (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)} - ${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },

    // 获取搜索参数
    getSearchParams () {
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        // total: 30  // 添加total参数，默认值为30
      }

      // 添加品牌筛选条件
      if (this.selectedFilters.brand !== 'all') {
        params.brand = this.selectedFilters.brand
      }

      // 添加车型筛选条件
      if (this.selectedFilters.type !== 'all') {
        params.type = this.selectedFilters.type
      }

      // 添加用途筛选条件
      if (this.selectedFilters.purpose !== 'all') {
        params.purpose = this.selectedFilters.purpose
      }

      // 添加燃油类型筛选条件
      if (this.selectedFilters.fuel !== 'all') {
        params.fuel = this.selectedFilters.fuel
      }

      // 价格过滤器需要特殊处理
      if (this.selectedFilters.price !== 'all') {
        switch (this.selectedFilters.price) {
          case 'less_20000':
            params.leastPrice = 0
            params.mostPrice = 20000
            break
          case '20001_40000':
            params.leastPrice = 20001
            params.mostPrice = 40000
            break
          case '40001_60000':
            params.leastPrice = 40001
            params.mostPrice = 60000
            break
          case '60001_80000':
            params.leastPrice = 60001
            params.mostPrice = 80000
            break
          case 'more_80001':
            params.leastPrice = 80001
            break
        }
      }

      return params
    },

    // 验证价格参数是否有效
    isPriceValid (price) {
      const validPrices = [
        'less_20000',
        '20001_40000',
        '40001_60000',
        '60001_80000',
        'more_80001'
      ];
      return validPrices.includes(price);
    },

    // 检查URL参数并设置筛选条件
    checkUrlParams () {
      const { purpose, brand, type, price, fuel, leastPrice, mostPrice, page, fromPage } = this.$route.query;

      // 处理页码参数
      if (page) {
        const pageNum = parseInt(page);
        if (!isNaN(pageNum) && pageNum > 0) {
          this.currentPage = pageNum;
          this.apiParams.pageNum = pageNum;
          console.log(`[All] Page parameter detected: ${pageNum}`);
        }
      } else if (fromPage) {
        // 如果有fromPage参数（从详情页返回），优先使用它
        const pageNum = parseInt(fromPage);
        if (!isNaN(pageNum) && pageNum > 0) {
          this.currentPage = pageNum;
          this.apiParams.pageNum = pageNum;
          console.log(`[All] Returning to page: ${pageNum} from detail page`);
        }
      }

      // 如果URL中有目的参数，更新筛选条件
      if (purpose) {
        // 只有当参数有效时才设置筛选条件
        if (this.isPurposeValid(purpose)) {
          this.selectedFilters.purpose = purpose;
          console.log(`[All] Purpose filter selected: ${purpose}`);
        } else {
          console.log(`[All] Invalid purpose parameter: ${purpose}, but keeping it in URL`);
        }
      }

      // 如果URL中有品牌参数，直接设置筛选条件
      if (brand) {
        this.selectedFilters.brand = brand;
        console.log(`[All] Brand filter selected: ${brand}`);
      }

      // 如果URL中有类型参数，直接设置筛选条件
      if (type) {
        this.selectedFilters.type = type;
        console.log(`[All] Type filter selected: ${type}`);
      }

      // 如果URL中有燃油类型参数，直接设置筛选条件
      if (fuel) {
        this.selectedFilters.fuel = fuel;
        console.log(`[All] Fuel filter selected: ${fuel}`);
      }

      // 如果URL中有价格参数，更新筛选条件
      if (price) {
        // 只有当参数有效时才设置筛选条件
        if (this.isPriceValid(price)) {
          this.selectedFilters.price = price;
          console.log(`[All] Price filter selected: ${price}`);
        } else {
          console.log(`[All] Invalid price parameter: ${price}, but keeping it in URL`);
        }
      }

      // 如果URL中有最低价和最高价参数，更新筛选条件
      if (leastPrice || mostPrice) {
        // 根据价格范围设置对应的价格档位
        const least = parseInt(leastPrice) || 0;
        const most = parseInt(mostPrice) || Infinity;

        if (most <= 20000) {
          this.selectedFilters.price = 'less_20000';
        } else if (least >= 20001 && most <= 40000) {
          this.selectedFilters.price = '20001_40000';
        } else if (least >= 40001 && most <= 60000) {
          this.selectedFilters.price = '40001_60000';
        } else if (least >= 60001 && most <= 80000) {
          this.selectedFilters.price = '60001_80000';
        } else if (least >= 80001) {
          this.selectedFilters.price = 'more_80001';
        }

        console.log(`[All] Price range filter selected: ${leastPrice}-${mostPrice}`);
      }

      // 如果有任何筛选条件从URL中设置，延迟执行滚动到选中项
      const hasFilterFromUrl = purpose || brand || type || fuel || price || leastPrice || mostPrice;

      // 只在客户端环境且非移动端时执行滚动
      if (hasFilterFromUrl && this.deviceType !== 'mobile' && typeof window !== 'undefined' && typeof document !== 'undefined') {
        // 使用setTimeout确保DOM完全更新后滚动
        setTimeout(() => {
          this.scrollToSelectedOptions();
        }, 500);
      }
    },

    // 更新URL参数
    updateUrlParams () {
      const params = {};

      // 如果选择了目的，添加到URL参数
      if (this.selectedFilters.purpose && this.selectedFilters.purpose !== 'all') {
        params.purpose = this.selectedFilters.purpose;
      }

      // 如果选择了品牌，添加到URL参数
      if (this.selectedFilters.brand && this.selectedFilters.brand !== 'all') {
        params.brand = this.selectedFilters.brand;
      }

      // 如果选择了类型，添加到URL参数
      if (this.selectedFilters.type && this.selectedFilters.type !== 'all') {
        params.type = this.selectedFilters.type;
      }

      // 如果选择了价格档位，添加到URL参数
      if (this.selectedFilters.price && this.selectedFilters.price !== 'all') {
        params.price = this.selectedFilters.price;
      }

      // 如果选择了燃油类型，添加到URL参数
      if (this.selectedFilters.fuel && this.selectedFilters.fuel !== 'all') {
        params.fuel = this.selectedFilters.fuel;
      }

      // 更新路由查询参数
      this.$router.push({
        query: params
      });
    },

    // 检查purpose是否有效
    isPurposeValid (purpose) {
      return this.filterOptions.purposes.some(option => option.value === purpose);
    },

    // 检查type是否有效
    isTypeValid (type) {
      return this.filterOptions.types.some(option => option.value === type);
    },

    // 更新筛选条件并触发接口请求
    updateFilter (filterType, newValue, event) {
      // 记录点击的元素所在的滚动容器
      const filterItemsContainer = event && event.target ? event.target.closest('.all-cars__filter-items') : null;
      // 保存当前滚动位置
      const scrollLeft = filterItemsContainer ? filterItemsContainer.scrollLeft : 0;

      this.selectedFilters[filterType] = newValue;
      this.updateUrlParams();

      // 重置页码到第一页
      this.currentPage = 1;

      // 调用接口获取新数据，但不重新获取品牌列表
      this.fetchCarList().then(() => {
        // 数据加载完成后，延迟滚动到选中项（在所有设备上生效）
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
          setTimeout(() => {
            this.scrollToSelectedOptions();
          }, 200);
        }
      });

      console.log(`[All] Filter updated: ${filterType} = ${newValue}, fetching new data`);

      // 使用 nextTick 确保在 DOM 更新后恢复之前的滚动位置（暂时保持用户当前的视图）
      this.$nextTick(() => {
        if (filterItemsContainer) {
          filterItemsContainer.scrollLeft = scrollLeft;
        }
      });
    },

    // 生成车辆详情页链接，保留 channel/query/page 证据参数。
    getCarDetailUrl (car) {
      if (!car || !car.id) {
        return '#';
      }

      // 获取当前路由的channel参数
      const currentChannel = this.$router.currentRoute.params.channel;

      // 格式化车辆名称，去除空格，用连字符替代
      const formattedName = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));

      // 添加当前页码参数
      const currentQuery = { ...this.$route.query };

      // 添加页码参数，如果当前页不是第一页
      if (this.currentPage > 1) {
        currentQuery.fromPage = this.currentPage;
      }

      const queryString = new URLSearchParams(currentQuery).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';
      const prefix = currentChannel ? `/${currentChannel}` : '';
      return `${prefix}/cars/${formattedName}/${car.id}${fullQueryString}`;
    },

    // 页码导航
    goToPage (page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) {
        return;
      }

      this.currentPage = page;

      // 重新获取数据
      this.fetchCarList();

      // 更新URL中的页码参数
      const query = { ...this.$route.query };

      // 如果页码为1，删除页码参数
      if (page === 1) {
        delete query.page;
      } else {
        query.page = page;
      }

      // 更新URL查询参数，但不触发路由变化
      this.$router.replace({ query }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });

      console.log('跳转到第' + page + '页');
    },

    // 滚动监听 (移动端)
    onScroll () {
      // 确保只在浏览器环境中执行DOM操作
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }

      // 如果正在加载或不在移动端，直接返回
      if (this.isLoading || this.deviceType !== 'mobile') {
        return;
      }

      const {
        scrollHeight,
        scrollTop,
        clientHeight
      } = document.documentElement;

      // 检查是否到达阈值
      if (scrollHeight - scrollTop - clientHeight < this.scrollThreshold) {
        this.loadMoreData();
      }
    },

    // 加载更多数据 (移动端)
    loadMoreData () {
      if (this.isLoading || this.currentPage >= this.totalPages) return;

      // 加载下一页数据
      this.currentPage++;
      const webIndex = this.domainConfig?.webIndex || 1;
      // 使用getSearchParams而不是直接修改apiParams，确保所有筛选条件都被应用
      const params = this.getSearchParams();
      params.pageNum = this.currentPage;

      console.log('加载第' + this.currentPage + '页数据...', params);
      this.isLoading = true;
      const mergedParams = {
        ...params,
        webIndex
      };

      // 调用API获取下一页数据
      this.$global.server.searchCar(mergedParams)
        .then(response => {
          if (response && response.data && response.data.list && Array.isArray(response.data.list)) {
            // 将新数据添加到现有数据中
            const newCars = response.data.list.map(item => this.formatCarData(item));

            if (newCars.length === 0) {
              // 如果没有更多数据，显示提示并不再允许加载更多
              this.totalPages = this.currentPage;
              console.log('没有更多数据');
            } else {
              this.cars = [...this.cars, ...newCars];

              // 移动端加载完数据后，也需要滚动到选中位置
              // 使用setTimeout确保DOM更新完成
              if (this.deviceType === 'mobile' && typeof window !== 'undefined' && typeof document !== 'undefined') {
                setTimeout(() => {
                  this.scrollToSelectedOptions();
                }, 200);
              }
            }
          }
        })
        .catch(error => {
          console.error('[All] Failed to load more data:', error);
          // 失败时回滚页码
          this.currentPage--;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },

    // 获取品牌列表数据（现在从Vuex获取，不再发送API请求）
    async getCarNameList () {
      // 如果Vuex中的品牌列表已加载，直接使用
      if (this.brandListLoaded) {
        console.log('使用Vuex中的品牌列表数据');

        // 检查当前选中的品牌是否在默认显示范围内
        this.checkSelectedBrandVisibility();
        return Promise.resolve(this.brandList);
      }

      // 如果Vuex中还没有品牌数据，等待App.vue中的初始化完成
      console.log('等待App.vue中的品牌列表初始化');
      return Promise.resolve([{ label: 'All', value: 'all' }]);
    },

    // 检查选中的品牌是否在可见范围内
    checkSelectedBrandVisibility () {
      // 如果当前选中的品牌不是'all'
      if (this.selectedFilters.brand && this.selectedFilters.brand !== 'all') {
        // 获取默认显示的品牌列表(前11个，包括'All')
        const defaultVisibleBrands = this.brandList.slice(0, 11)

        // 检查当前选中的品牌是否在默认显示的范围内
        const brandInDefaultVisible = defaultVisibleBrands.some(
          brand => brand.value === this.selectedFilters.brand
        )

        // 如果不在默认显示范围内，自动展开品牌列表
        if (!brandInDefaultVisible) {
          console.log(`[All] Selected brand "${this.selectedFilters.brand}" is not in default visible brands, expanding brand list`)
          this.brandExpanded = true
        }
      }
    },

    checkVuexState () {
      // Implementation of checkVuexState method
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.all-cars {
	min-height: 100vh;
	background: #fff;

	&__main-container {
		display: flex;
		flex-direction: row;
		width: 100%;
		padding: rem(60) rem(120);
		gap: rem(40);
	}

	&__content {
		flex: 1;
	}

	&__filters {
		width: rem(264);
	}

	&__mobile-filters {
		display: none;
	}

	&__filter-section {
		margin-bottom: rem(30);
	}

	&__filter-title {
		font-size: rem(16);
		font-weight: 600;
		color: #141414;
		margin-bottom: rem(16);
	}

	&__filter-options {
		display: flex;
		flex-wrap: wrap;
		gap: rem(10);
		// max-height: rem(180);
		overflow-y: auto;

		&--expanded {
			max-height: none;
		}
	}

	&__filter-option {
		padding: rem(8) rem(16);
		border-radius: rem(8);
		background: #f5f5f5;
		color: #141414;
		font-size: rem(14);
		cursor: pointer;
		transition: all 0.2s ease;
		margin-bottom: rem(10);

		&:hover {
			background: #e0e0e0;
		}

		&--active {
			background: var(--theme-color);
			color: #ffffff;

			&:hover {
				background: #e87800;
			}
		}
	}

	&__filter-more {
		margin-top: rem(10);
		color: var(--theme-color);
		font-size: rem(14);
		cursor: pointer;
		display: inline-block;
	}

	&__cards {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: rem(20);
		margin-bottom: rem(40);
	}

	&__card {
		overflow: hidden;
		cursor: pointer;
		transition: transform 0.3s ease;
		border-radius: rem(24);
		border: 1px solid #e9e9e9;
		background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 50%, rgba(var(--theme-color-r), var(--theme-color-g), var(--theme-color-b), 0.08) 100%);
		padding: rem(20);

		&:hover {
			transform: translateY(-4px);
		}
	}

	&__pic {
		width: 100%;
		height: rem(164);
		object-fit: cover;
		border-radius: rem(16);
		border: rem(1) solid #fff;
		background: lightgray 50% / cover no-repeat;
	}

	&__header {
		padding: rem(16) rem(16) rem(10);
		display: flex;
		flex-direction: column;
		gap: rem(10);
	}

	&__year {
		font-size: rem(14);
		color: #777777;
	}

	&__car-header {
		display: flex;
		align-items: center;
		gap: rem(20);
		margin-bottom: rem(20);
	}

	&__brand-logo {
		width: rem(40);
		height: rem(40);
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ffffff;
		border-radius: 50%;
		border-radius: 100px;
		border: 1px solid #e9e9e9;
		background: lightgray 50% / cover no-repeat, #fff;

		img {
			width: rem(40);
			height: rem(40);
			object-fit: contain;
		}
	}

	&__car-info {
		display: flex;
		flex-direction: column;
		gap: rem(8);
	}

	&__model {
		font-size: rem(16);
		font-weight: 600;
		line-height: rem(16); /* 100% */
		color: #141414;
	}

	&__brand {
		font-size: rem(12);
		line-height: rem(12); /* 100% */
		color: #777777;
	}

	&__info {
		padding: rem(12) 0;
		display: flex;
		flex-direction: column;
		gap: rem(8);
	}

	&__feature {
		display: flex;
		align-items: center;
		gap: rem(10);
	}

	&__icon {
		width: rem(16);
		height: rem(16);
	}

	&__feature-text {
		font-size: rem(14);
		color: #141414;
	}

	&__price {
		padding: rem(16) 0 0;
		border-top: 2px solid #fff;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: rem(20);
	}

	&__price-head {
		color: #777;
		text-align: center;
		font-size: rem(12);
		font-style: normal;
		font-weight: 400;
		line-height: rem(12);
	}

	&__price-text {
		color: var(--theme-color);
		text-align: center;
		font-size: rem(18);
		font-style: normal;
		font-weight: 700;
		line-height: rem(20);
		span {
			color: #141414;
			font-size: rem(12);
			font-style: normal;
			font-weight: 700;
			line-height: rem(20);
		}
	}

	&__rating {
		position: absolute;
		top: rem(16);
		right: rem(16);
		display: flex;
		align-items: center;
		background: var(--theme-color);
		color: white;
		padding: rem(6) rem(10);
		border-radius: rem(20);
	}

	&__rating-value {
		font-size: rem(16);
		font-weight: 700;
	}

	&__rating-max {
		font-size: rem(12);
	}

	&__pagination {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: rem(8);
		margin-top: rem(40);
	}

	&__pagination-page {
		width: rem(40);
		height: rem(40);
		border-radius: rem(8);
		background: #f5f5f5;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: rem(14);
		color: #4c5164;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			background: #e0e0e0;
		}

		&--active {
			background: var(--theme-color);
			color: #ffffff;

			&:hover {
				background: #e87800;
			}
		}
	}

	&__pagination-arrow {
		width: rem(40);
		height: rem(40);
		border-radius: rem(8);
		background: #f5f5f5;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			background: #e0e0e0;
		}
	}

	&__pagination-arrow-icon {
		width: rem(24);
		height: rem(24);
	}

	&__pagination-ellipsis {
		font-size: rem(14);
		color: #4c5164;
		padding: 0 rem(8);
	}

	&__no-results {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		padding: rem(40) 0 rem(60);

		&-text {
			font-size: rem(16);
			color: #848998;
			text-align: center;
		}
	}

	&__load-more {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		padding: rem(20) 0;

		&-text {
			font-size: rem(14);
			color: #848998;
			text-align: center;
		}
	}
}

// PC 设备类
.detect_deviece_pc,
.detect_deviece_desktop {
	.all-cars {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// Mobile 设备类
.detect_deviece_mobile {
	.all-cars {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);

		&__main-container {
			flex-direction: column;
			padding: 0;
		}

		&__content {
			padding: 0 rem(16);
			order: 2;
		}

		&__filters {
			display: none;
		}

		&__mobile-filters {
			order: 1;
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: rem(16);
		}

		&__cards {
			grid-template-columns: 1fr;
			gap: rem(16);
		}

		&__filter {
			flex-direction: column;
			align-items: flex-start;
			padding-left: rem(16);
			gap: rem(10);
			display: flex;
		}

		&__filter-label {
			font-size: rem(14);
			line-height: rem(20);
			width: 100%;
			font-weight: 600;
			color: #141414;
		}

		&__filter-items {
			width: 100%;
			padding: 0;
			margin: 0;
			display: flex;
			overflow-x: auto;
			white-space: nowrap;
			scrollbar-width: none;
			-ms-overflow-style: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__filter-item {
			font-size: rem(12);
			padding: rem(6) rem(12);
			border-radius: rem(16);
			background: #f5f5f5;
			color: #141414;
			margin-right: rem(8);
			display: inline-block;
			cursor: pointer;

			&--active {
				background: var(--theme-color);
				color: #ffffff;
			}
		}

		&__filter-toggle {
			display: flex;
			align-items: center;
			gap: rem(8);
			font-size: rem(12);
			color: var(--theme-color);
			cursor: pointer;

			&-icon {
				width: rem(10);
				height: rem(6);
			}
		}
	}
}
</style>
